import { styled } from 'styled-components';

const ModalHeader = styled.div`
	font-size: 24px;
	margin-bottom: ${(props) => props.theme.spacing(4)};
	text-align: left;
`;

export default ModalHeader;
